import { render, staticRenderFns } from "./CreateStoreTransfer.vue?vue&type=template&id=284e7509&scoped=true&"
import script from "./CreateStoreTransfer.vue?vue&type=script&lang=js&"
export * from "./CreateStoreTransfer.vue?vue&type=script&lang=js&"
import style0 from "./CreateStoreTransfer.vue?vue&type=style&index=0&id=284e7509&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284e7509",
  null
  
)

export default component.exports